// Financial — reports.financial.*
export const FINANCIAL_REPORTS_TRIAL_BALANCE = 1228;
export const FINANCIAL_REPORTS_BALANCE_SHEET = 1229;
export const FINANCIAL_REPORTS_INCOME_STATEMENT = 1230;
export const FINANCIAL_REPORTS_CASH_FLOW = 1231;
export const FINANCIAL_REPORTS_GENERAL_LEDGER = 1232;
export const FINANCIAL_REPORTS_ACCOUNT_LEDGER = 1233;
export const FINANCIAL_REPORTS_SUB_LEDGER = 1234;
export const FINANCIAL_REPORTS_COST_CENTER_PL = 1235;
export const FINANCIAL_REPORTS_DEPRECIATION = 1236;
export const FINANCIAL_REPORTS_SETTLEMENT_AGING = 1237;
export const FINANCIAL_REPORTS_VAT_RETURN = 1238;
export const FINANCIAL_REPORTS_VAT_DETAILED = 1239;

// Finance close & control — reports.financial.*
// Central key service approval numbers, issued 21 Sep 2026; the backend migration
// writes each as that permission row's id, so the two must stay equal.
export const FINANCIAL_REPORTS_SUBLEDGER_RECONCILIATION = 1611;
export const FINANCIAL_REPORTS_PROOF_OF_CASH = 1612;
export const FINANCIAL_REPORTS_SEGMENT = 1613;
export const FINANCIAL_REPORTS_RELATED_PARTY = 1614;

// Executive financial overview — standalone top-manager page.
// Backend key: reports.financial.executive-overview.
// 1420 is confirmed against the live permission set — the note that used to sit here was
// written before the migration ran and guessed at it.
export const FINANCIAL_REPORTS_EXECUTIVE_OVERVIEW = 1420;

// Inventory — reports.inventory.*
export const INVENTORY_REPORTS_STOCK_ON_HAND = 1240;
export const INVENTORY_REPORTS_MOVEMENT_LEDGER = 1241;
export const INVENTORY_REPORTS_AGED_STOCK = 1242;
export const INVENTORY_REPORTS_VOUCHERS_REGISTER = 1243;
export const INVENTORY_REPORTS_VALUATION_BY_CATEGORY = 1244;
export const INVENTORY_REPORTS_GL_RECONCILIATION = 1615;

// Customer dues — reports.customer-dues.*
export const FINANCIAL_REPORTS_AR_AGING = 1245;
export const CUSTOMER_DUES_COLLECTIONS_PERFORMANCE = 1246;
export const CUSTOMER_DUES_CASHFLOW_FORECAST = 1247;
export const CUSTOMER_DUES_STATEMENT = 1248;
export const CUSTOMER_DUES_SERVICE_REVENUE = 1249;

// Owner & vouchers — reports.owner.* / reports.vouchers.*
export const OWNER_REMITTANCE_PENDING = 1250;
export const OWNER_EARNINGS_STATEMENT = 1251;
export const OWNER_LEDGER = 1252;
export const VOUCHER_CASHBOOK = 1253;

// Sidebar gate for Owner / vouchers reports (same capability as first owner report)
export const OWNER_VOUCHERS_REPORTS_INDEX = OWNER_REMITTANCE_PENDING;

export const CUSTOMER_DUES_REVENUE_ANALYSIS = 1254;
export const CUSTOMER_DUES_OVERDUE_BY_ASSET = 1255;

// CRM — reports.crm.*
export const CRM_PIPELINE_FUNNEL = 1256;
export const CRM_LEAD_SOURCE_ROI = 1257;
export const CRM_CLOSED_LOST_REASONS = 1258;
export const CRM_AGENT_PERFORMANCE = 1259;
export const CRM_MATCH_QUALITY = 1260;
export const CRM_ACTIVITY_AGING = 1261;
export const CRM_WEIGHTED_FORECAST = 1262;
/**
 * reports.crm.forecast_accuracy — grades the weighted forecast against what closed.
 *
 * Out of the 12xx run because it was approved centrally much later; the number is assigned
 * by the permission registry, not by this file, so it cannot be renumbered to sit in order.
 */
export const CRM_FORECAST_ACCURACY = 1454;

export const CRM_REPORTS_INDEX = CRM_PIPELINE_FUNNEL;

// Properties — reports.properties.*
export const PROP_PORTFOLIO_OVERVIEW = 1263;
export const PROP_OCCUPANCY_STATUS = 1264;
export const PROP_VACANCY_DOM = 1265;
export const PROP_CONTRACT_EXPIRY = 1266;
export const PROP_SALES_PIPELINE = 1267;
export const PROP_BOOKING_PERFORMANCE = 1268;
export const PROP_MARKETPLACE_PERFORMANCE = 1269;
export const PROP_PROFITABILITY = 1270;
export const PROP_OWNER_PORTFOLIO = 1271;
export const PROP_MAINTENANCE_HISTORY = 1272;

export const PROPERTIES_REPORTS_INDEX = PROP_PORTFOLIO_OVERVIEW;

// Rent contracts — reports.rent.*
export const RENT_ACTIVE_ROLL = 1273;
export const RENT_LIFECYCLE_FUNNEL = 1274;
export const RENT_RENEWAL_FORECAST = 1275;
export const RENT_TERMINATIONS = 1276;
export const RENT_EJAR_STATUS = 1277;

export const RENT_REPORTS_INDEX = RENT_ACTIVE_ROLL;

// Sell contracts — reports.sell.*
export const SELL_SALES_PIPELINE = 1278;
export const SELL_INSTALLMENTS_SCHEDULE = 1279;
export const SELL_CANCELLATIONS = 1280;
export const SELL_DISCOUNT_ANALYSIS = 1281;

export const SELL_REPORTS_INDEX = SELL_SALES_PIPELINE;

// Booking — reports.booking.*
export const BOOKING_CALENDAR_HEATMAP = 1282;
export const BOOKING_UTILIZATION_REVPAR = 1283;
export const BOOKING_BLACKOUT_IMPACT = 1284;

export const BOOKING_REPORTS_INDEX = BOOKING_CALENDAR_HEATMAP;

// Sidebar OR-gates — show category if user has any report in the group
export const FINANCIAL_REPORTS_PERMISSIONS = [
  FINANCIAL_REPORTS_TRIAL_BALANCE,
  FINANCIAL_REPORTS_BALANCE_SHEET,
  FINANCIAL_REPORTS_INCOME_STATEMENT,
  FINANCIAL_REPORTS_CASH_FLOW,
  FINANCIAL_REPORTS_GENERAL_LEDGER,
  FINANCIAL_REPORTS_ACCOUNT_LEDGER,
  FINANCIAL_REPORTS_SUB_LEDGER,
  FINANCIAL_REPORTS_COST_CENTER_PL,
  FINANCIAL_REPORTS_DEPRECIATION,
  FINANCIAL_REPORTS_SETTLEMENT_AGING,
  FINANCIAL_REPORTS_VAT_RETURN,
  FINANCIAL_REPORTS_VAT_DETAILED,
  FINANCIAL_REPORTS_SUBLEDGER_RECONCILIATION,
  FINANCIAL_REPORTS_PROOF_OF_CASH,
  FINANCIAL_REPORTS_SEGMENT,
  FINANCIAL_REPORTS_RELATED_PARTY,
];

export const INVENTORY_REPORTS_PERMISSIONS = [
  INVENTORY_REPORTS_STOCK_ON_HAND,
  INVENTORY_REPORTS_MOVEMENT_LEDGER,
  INVENTORY_REPORTS_AGED_STOCK,
  INVENTORY_REPORTS_VOUCHERS_REGISTER,
  INVENTORY_REPORTS_VALUATION_BY_CATEGORY,
  INVENTORY_REPORTS_GL_RECONCILIATION,
];

export const CUSTOMER_DUES_REPORTS_PERMISSIONS = [
  FINANCIAL_REPORTS_AR_AGING,
  CUSTOMER_DUES_COLLECTIONS_PERFORMANCE,
  CUSTOMER_DUES_CASHFLOW_FORECAST,
  CUSTOMER_DUES_STATEMENT,
  CUSTOMER_DUES_SERVICE_REVENUE,
  CUSTOMER_DUES_REVENUE_ANALYSIS,
  CUSTOMER_DUES_OVERDUE_BY_ASSET,
];

export const OWNER_VOUCHERS_REPORTS_PERMISSIONS = [
  OWNER_REMITTANCE_PENDING,
  OWNER_EARNINGS_STATEMENT,
  OWNER_LEDGER,
  VOUCHER_CASHBOOK,
];

export const CRM_REPORTS_PERMISSIONS = [
  CRM_PIPELINE_FUNNEL,
  CRM_LEAD_SOURCE_ROI,
  CRM_CLOSED_LOST_REASONS,
  CRM_AGENT_PERFORMANCE,
  CRM_MATCH_QUALITY,
  CRM_ACTIVITY_AGING,
  CRM_WEIGHTED_FORECAST,
  CRM_FORECAST_ACCURACY,
];

export const PROPERTIES_REPORTS_PERMISSIONS = [
  PROP_PORTFOLIO_OVERVIEW,
  PROP_OCCUPANCY_STATUS,
  PROP_VACANCY_DOM,
  PROP_CONTRACT_EXPIRY,
  PROP_SALES_PIPELINE,
  PROP_BOOKING_PERFORMANCE,
  PROP_MARKETPLACE_PERFORMANCE,
  PROP_PROFITABILITY,
  PROP_OWNER_PORTFOLIO,
  PROP_MAINTENANCE_HISTORY,
];

export const RENT_REPORTS_PERMISSIONS = [
  RENT_ACTIVE_ROLL,
  RENT_LIFECYCLE_FUNNEL,
  RENT_RENEWAL_FORECAST,
  RENT_TERMINATIONS,
  RENT_EJAR_STATUS,
];

export const SELL_REPORTS_PERMISSIONS = [
  SELL_SALES_PIPELINE,
  SELL_INSTALLMENTS_SCHEDULE,
  SELL_CANCELLATIONS,
  SELL_DISCOUNT_ANALYSIS,
];

export const BOOKING_REPORTS_PERMISSIONS = [
  BOOKING_CALENDAR_HEATMAP,
  BOOKING_UTILIZATION_REVPAR,
  BOOKING_BLACKOUT_IMPACT,
];
